var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4A4A4A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12279",
    transform: "translate(-1219.661 -169)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1247.1,186.8h-6.9c-2.8,0-5.1-2.3-5.1-5.1v-6.9c0-2.8,2.3-5.1,5.1-5.1h6.9c2.8,0,5.1,2.3,5.1,5.1v6.9 C1252.2,184.5,1249.9,186.8,1247.1,186.8z M1240.2,173.2c-0.9,0-1.7,0.8-1.7,1.7v6.9c0,0.9,0.8,1.7,1.7,1.7h6.9 c0.9,0,1.7-0.8,1.7-1.7v-6.9c0-0.9-0.8-1.7-1.7-1.7H1240.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1233.4,216.2h-6.8c-2.8,0-5.1-2.3-5.1-5.1V206c0-2.8,2.3-5.1,5.1-5.1h6.8c2.8,0,5.1,2.3,5.1,5.1v5.1 C1238.5,213.9,1236.2,216.2,1233.4,216.2z M1226.6,204.3c-0.9,0-1.7,0.8-1.7,1.7v5.1c0,0.9,0.8,1.7,1.7,1.7h6.8 c0.9,0,1.7-0.8,1.7-1.7V206c0-0.9-0.8-1.7-1.7-1.7H1226.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1260.7,216.2h-6.8c-2.8,0-5.1-2.3-5.1-5.1V206c0-2.8,2.3-5.1,5.1-5.1h6.8c2.8,0,5.1,2.3,5.1,5.1v5.1 C1265.8,213.9,1263.5,216.2,1260.7,216.2z M1253.9,204.3c-0.9,0-1.7,0.8-1.7,1.7v5.1c0,0.9,0.8,1.7,1.7,1.7h6.8 c0.9,0,1.7-0.8,1.7-1.7V206c0-0.9-0.8-1.7-1.7-1.7H1253.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1230.2,204.1c-0.9,0-1.7-0.8-1.7-1.7v-5.4c0-3,2.7-4,4.6-4h7.6c1.1,0,1.3-0.4,1.3-0.8l0-3 c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7v2.9c0,0.1,0.1,1.7-1.1,2.9c-0.6,0.6-1.7,1.4-3.6,1.4h-7.6c-0.1,0-1.2,0-1.2,0.6v5.4 C1231.9,203.3,1231.1,204.1,1230.2,204.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1257.1,204.1c-0.9,0-1.7-0.8-1.7-1.7v-5.4c0-0.6-1.1-0.6-1.2-0.6h-7.6c-1.9,0-3-0.7-3.6-1.4 c-1.2-1.2-1.1-2.8-1.1-3l0-6.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7v6.8c0,0.4,0.1,0.9,1.3,0.9h7.6c1.8,0,4.6,1.1,4.6,4 v5.4C1258.8,203.3,1258.1,204.1,1257.1,204.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.5353b8435ee9f08865bd3585af71a45f.svg";
export { ForwardRef as ReactComponent };